import { SIZE } from 'baseui/button'
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid'
import AssistanceForm from './AssistanceForm/AssistanceForm'
import AssistanceList from './AssistanceList'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { Modal, ModalHeader, ModalBody } from 'baseui/modal'
import Paginator from '@/shared/components/Paginator'
import SearchInTable from '@/shared/components/SearchInTable'
import useAssistance from './useAssistance'
import { Card, Header1 } from '@/shared/theme/styled-components'

const AssistanceProducts = () => {
  const {
    t,
    assistanceProducts,
    isLoading,
    elementsPerPage,
    isOpen,
    close,
    page,
    setPage,
    setAssistanceHandler,
    updateAssistanceSelected,
    selectedAssistance,
  } = useAssistance()

  const flexGridItemProps = {
    display: 'flex',
    alignItems: 'center',
  }

  if (isLoading) {
    return <p>{t('common:fetching_data')}</p>
  }

  return (
    <Card>
      <Header1>{t('assistanceConfiguration:title')}</Header1>
      <FlexGrid flexGridColumnCount={2} marginBottom={'.5rem'}>
        <FlexGridItem {...flexGridItemProps}>
          <SDButton key={0} block={false} size={SIZE.compact} onClick={() => updateAssistanceSelected(null)}>
            {t('assistanceConfiguration:create_button')}
          </SDButton>
        </FlexGridItem>
        <FlexGridItem {...flexGridItemProps}>
          <SearchInTable setElements={setAssistanceHandler} elements={assistanceProducts} />
        </FlexGridItem>
      </FlexGrid>
      <AssistanceList
        items={assistanceProducts}
        page={page}
        elementsPerPage={elementsPerPage}
        updateAssistance={updateAssistanceSelected}
      />
      <Paginator elementsPerPage={elementsPerPage} page={page} setPage={setPage} elements={assistanceProducts} />
      <Modal onClose={close} isOpen={isOpen}>
        <ModalHeader>
          {!selectedAssistance?.id || selectedAssistance.id === 0
            ? t('assistanceConfiguration:modal_header_create')
            : t('assistanceConfiguration:modal_header_update')}
        </ModalHeader>
        <ModalBody>
          <AssistanceForm onCancel={close} />
        </ModalBody>
      </Modal>
    </Card>
  )
}

export default AssistanceProducts
